// extracted by mini-css-extract-plugin
module.exports = {"mallList__list":"style_mallList__list__Mn6ae"};